import React, { useContext, useEffect, useRef } from "react";
import { Animated, Platform, StyleSheet } from "react-native";
import { tvgColorPalette as colors } from "../../../../theming/themes/common";
import { TabsContext } from "../../tabs";
import { TabSelectionIndicatorProps } from "./types";

const isWeb = Platform.OS === "web";
export const TabSelectionIndicator = ({
  width,
  x,
  tabSelectionIndicatorColor
}: TabSelectionIndicatorProps) => {
  const { selectedValue, tabsLayout } = useContext(TabsContext);
  const translation = useRef(new Animated.Value(x)).current;

  useEffect(() => {
    Animated.timing(translation, {
      toValue: x,
      useNativeDriver: !isWeb,
      duration: 200
    }).start();
  }, [selectedValue, tabsLayout]);

  return (
    <Animated.View
      style={[
        styles.slider,
        {
          width,
          backgroundColor:
            tabSelectionIndicatorColor || colors.blue_accent[500],
          transform: [{ translateX: translation }]
        }
      ]}
    />
  );
};

const styles = StyleSheet.create({
  slider: {
    position: "absolute",
    top: 46,
    height: 2
  }
});

export type { TabSelectionIndicatorProps };
